export default class LocalizationUtility {

    requestUrl = null;
    localizationData = null;
    initialized = false;

    constructor(requestUrl)  {
        this.requestUrl = requestUrl;
    }

    async init() {
        try {
            const response = await fetch(this.requestUrl);
            console.log(response);
            if (!response.ok) {
                throw new Error('Request failed: ' + response.statusText);
            }

            this.localizationData = await response.json();
            this.initialized = true;
        } catch (error) {
            console.error('Localization init failed:', error);
            // optional: eigene Fehlerbehandlung oder Re-Throw
            throw error;
        }
    }

    translate(key) {
        if(key in this.localizationData) {
            return this.localizationData[key];
        }
    }

    getAll() {
        return this.localizationData;
    }

}
